import { ComponentType } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import consoleLog from "../utils/consoleLog";

import { userActions } from "../redux/user/user.reducer";

const signIn = (dispatch: any, username: string | undefined) => {
  dispatch({
    type: userActions.signInStart.type,
    payload: username,
  });
};

export default function withAuth<T>(Component: ComponentType<T>) {
  return (hocProps: T) => {
    const dispatch = useDispatch();
    consoleLog("withAuth working");

    if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
      consoleLog("cookies", Cookies);

      if (Cookies.get("idToken")) {
        signIn(dispatch, Cookies.get("username"));
      } else {
        window.alert("Need to Log in");
        window.location.href = `https://login.petobe.ca/login?urlFrom=${window.location.href}`;
      }
    }

    return <Component {...(hocProps as T)} />;
  };
}
